<template>
  <v-card color_="blue-grey darken-2" class_="white--text" class="elevation-2">
    <v-card-title primary-title class_="blue-grey darken-2">
      <div>
        <div class="subtitle-1 font-weight-medium mb-2">
          Produtos Vendidos
        </div>
        <div class="body-2">Relação dos produtos vendidos no período.</div>
      </div>
    </v-card-title>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" @click="$refs.dialogo.abrir()">Opções</v-btn>
    </v-card-actions>

    <v-divider v-show="aberto"></v-divider>

    <z-dialogo ref="dialogo" titulo="Produtos Vendidos" largura="500px" persistent>
      <template v-slot:texto>
        <v-row dense>
          <v-col cols="12" sm="6">
            <z-date-picker-menu filled dense label="Data Incial" v-model="filtro.data_inicial"></z-date-picker-menu>
          </v-col>
          <v-col cols="12" sm="6">
            <z-date-picker-menu filled dense label="Data Final" v-model="filtro.data_final"></z-date-picker-menu>
          </v-col>
          <v-col cols="12">
            <v-select filled dense :items="ordenacao" label="Ordenar por" placeholder=" " v-model="filtro.ordem"></v-select>
          </v-col>
          <v-col cols="12">
            <v-switch
              v-model="filtro.agrupado"
              color="primary"
              label="Agrupar por Grupo de produtos"
              hide-details
              filled
              dense
              class="mt-0"
            ></v-switch>
          </v-col>
          <v-col cols="12">
            <v-select 
              v-model="filtro.grupo_id"
              filled 
              dense 
              label="Grupos"
              clearable
              :items="$store.state.listas.produtos_grupos"
              :disabled="!filtro.agrupado"
            ></v-select>
          </v-col>
        </v-row>
      </template>

      <template v-slot:actions_right>
        <v-spacer></v-spacer>
        <v-btn text @click="$refs.dialogo.fechar()">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimir">Imprimir</v-btn>
      </template>
    </z-dialogo>

    <v-divider></v-divider>

    <!-- <v-card-actions class="white" v-show="aberto">
      <v-spacer></v-spacer>
      <v-btn icon v-show="aberto" @click="imprimir">
        <v-icon>print</v-icon>
      </v-btn>
    </v-card-actions> -->
  </v-card>
</template>

<script>
export default {
  name: "produtos-mais-vendidos",
  data() {
    return {
      aberto: false,
      filtro: {
        data_inicial: this.$moment().format("YYYY-MM-DD"),
        data_final: this.$moment().format("YYYY-MM-DD"),
        ordem: "quantidade_total",
        agrupado: false,
        grupo_id: null
      },
      ordenacao: [
        { text: "Quantidade", value: "quantidade_total" },
        { text: "Descrição", value: "descricao" },
        { text: "Referência", value: "referencia" },
      ],
    };
  },

  inject: ['$imprimir'],

  methods: {
    imprimir() {
      this.$imprimir("relatorios/produtosmaisvendidos?" + new URLSearchParams(this.filtro).toString(), "produtos_mais_vendidos.pdf");
    },
  },
};
</script>

<style scoped></style>
